import React from 'react'

import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {AmenidadesItem} from './AmenidadesItem'

function Amenidades(props) {
  const displayItems = (props) => {
    if (props) {
      const amenidades = props.amenidades

      console.log(amenidades.length)

      if (amenidades) {
        if (amenidades.length > 0) {
          return amenidades.map((amenidad, index) => {
            return <AmenidadesItem key={index} amenidad={amenidad} />
          })
        } else {
          return <h3>No hay amenidades</h3>
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  return <>{displayItems(props)}</>
}

export {Amenidades}
